/**
 * `crypto.randomUUID()` with a fallback for browsers that lack it. Our browserslist supports
 * Chrome ≥80 / Firefox ≥85 / Safari ≥14, but `crypto.randomUUID` only shipped in Chrome 92 /
 * Firefox 95 / Safari 15.4 — ~0.15% of real sessions run below that, and an unguarded call throws.
 * The fallback is not a valid UUID, only a collision-resistant unique string (that's all every
 * caller needs: request-correlation ids, stream ids, optimistic message ids).
 */
export function safeRandomUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
